const FONT_EXTENSION_PATTERN = /\.(?:woff2?|ttf|otf|eot)$/i

const loadedUrls = new Set<string>()

function directFontFamily(url: string): string {
  try {
    const pathname = new URL(url, document.baseURI).pathname
    const filename = decodeURIComponent(pathname.split('/').pop() || '')
    const family = filename.replace(FONT_EXTENSION_PATTERN, '').trim()
    return family || 'CustomFont'
  } catch {
    return 'CustomFont'
  }
}

export function loadFonts(urls: string[]) {
  for (const url of urls) {
    if (loadedUrls.has(url)) continue
    loadedUrls.add(url)

    if (url.includes('fonts.googleapis.com') || url.endsWith('.css')) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = url
      document.head.appendChild(link)
    } else {
      const style = document.createElement('style')
      const family = directFontFamily(url)
      style.textContent = `@font-face { font-family: ${JSON.stringify(family)}; src: url(${JSON.stringify(url)}); font-style: normal; font-weight: normal; font-display: swap; }`
      document.head.appendChild(style)
    }
  }
}
